import { useState, useContext } from "react";
import { Outlet } from "react-router-dom";

import uruguayLSQA from "../../assets/images/uruguay-lsqa.svg";
import whatsapp from "../../assets/images/whatsapp.svg";
import { UserContext } from "../../context/UserContext";
import { logout } from "../../login";
import { ErrorBoundary } from "./ErrorBoundary";

export function Layout() {
	const [showLoader, setShowLoader] = useState(false);
	const { user, setUser } = useContext(UserContext);

	const handleClick = () => {
		logout();
		setUser(null);
	};

	return (
		<>
			<header>
				<div className="logos-header">
					<a href="/" target="_self">
						<img className="uruguay-lsqa" src={uruguayLSQA} alt="Logo Uruguay - LSQA" />
					</a>
				</div>
				<h1>Solicitud de licenciamiento Marca País Uruguay</h1>
			</header>
			<main>
				<ErrorBoundary>
					<Outlet context={[setShowLoader]} />
				</ErrorBoundary>
			</main>
			<a
				id="whatsapp"
				href="https://api.whatsapp.com/send?phone=59894048252&text=Hola%2C%20quisiera%20me%20brinden%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20Solicitud%20de%20Licenciamiento%20Marca%20Pa%C3%ADs%20Uruguay."
				target="_blank"
				rel="noreferrer"
			>
				<img src={whatsapp} alt="WhatsApp" />
			</a>
			{user && (
				<button className="btn-logout" type="button" onClick={handleClick}>
					LOGOUT
				</button>
			)}
			{showLoader && (
				<div className="loader-wrapper">
					<div className="loader"></div>
				</div>
			)}
		</>
	);
}
